export default __webpack_public_path__ + "static/banner-hosting-christmas-lunch-v3-594580f3928c3fd29d4ddaa65f6d31d8.jpg";